import { currenciesConstants } from "../constants/action.constants";
import { currencyService } from "../services/currencies.service";
import { alertActions } from "../../Alert/actions/alert.actions";
import { message, routeConstants } from "../../../_constants";
import { history } from "../../../_utils";

export const currencyActions = {
  addCurrency,
  getAllCurrencies,
  getCurrency,
  resetCurrency,
  resetAddCurrency
};

function getAllCurrencies() {
  return async dispatch => {
    dispatch(request());
    try {
      const response = await currencyService.getAllCurrencies();
      response && dispatch(success(response));
    } catch (error) {
      dispatch(failure(error));
      dispatch(
        alertActions.error(
          error ? error.message : message.GENERIC_ERROR,
          message.LOAD_CURRENCIES
        )
      );
    }
  };

  function request() {
    return { type: currenciesConstants.GET_CURRENCIES_REQUEST };
  }
  function success(response) {
    return { type: currenciesConstants.GET_CURRENCIES_SUCCESS, response };
  }
  function failure(error) {
    return { type: currenciesConstants.GET_CURRENCIES_FAILURE, error };
  }
}

function getCurrency(id) {
  return async dispatch => {
    dispatch(request(id));
    try {
      const response = await currencyService.getCurrency(id);
      response && dispatch(success(response));
    } catch (error) {
      dispatch(failure(error));
      dispatch(
        alertActions.error(
          error ? error.message : message.GENERIC_ERROR,
          `${message.GET_CURRENCY}: ${id}`
        )
      );
    }
  };

  function request(id) {
    return { type: currenciesConstants.VIEW_CURRENCY_REQUEST, id };
  }
  function success(response) {
    return { type: currenciesConstants.VIEW_CURRENCY_SUCCESS, response };
  }
  function failure(error) {
    return { type: currenciesConstants.VIEW_CURRENCY_FAILURE, error };
  }
}

function addCurrency(requestBody) {
  return async dispatch => {
    dispatch(request(requestBody));
    try {
      const response = await currencyService.addCurrency(requestBody);
      response && dispatch(success(response));
      dispatch(getAllCurrencies());
      if (requestBody.id) {
        history.push(routeConstants.CURRENCIES.path);
      }
      dispatch(
        alertActions.success(
          response && response.responseMessage,
          requestBody.id ? message.EDIT_CURRENCY : message.ADD_CURRENCY
        )
      );
      dispatch(resetAddCurrency());
      dispatch(resetCurrency());
    } catch (error) {
      dispatch(failure(error));
      dispatch(
        alertActions.error(
          error ? error.message : message.GENERIC_ERROR,
          requestBody.id ? message.EDIT_CURRENCY : message.ADD_CURRENCY
        )
      );
    }
  };

  function request(requestBody) {
    return { type: currenciesConstants.ADD_CURRENCY_REQUEST, requestBody };
  }
  function success(response) {
    return { type: currenciesConstants.ADD_CURRENCY_SUCCESS, response };
  }
  function failure(error) {
    return { type: currenciesConstants.ADD_CURRENCY_FAILURE, error };
  }
}

function resetCurrency() {
  return { type: currenciesConstants.VIEW_CURRENCY_RESET };
}

function resetAddCurrency() {
  return { type: currenciesConstants.ADD_CURRENCY_RESET };
}
